import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FinoButtonModule } from '@fino-ui/button';
import { FinoIconModule } from '@fino-ui/icon';
import { FinoTranslationModule } from '@fino-ui/translation';
import type { TransactionType } from '@modules/correction-tool/correction-tool.models';

@Component({
  selector: 'app-new-table',
  imports: [
    CommonModule,
    FinoButtonModule,
    FinoTranslationModule,
    FinoIconModule,
  ],
  templateUrl: './new-table.component.html',
  styleUrl: './new-table.component.sass',
})
export class NewTableComponent {
  @Output()
  public transactionTypeSelected = new EventEmitter<TransactionType>();

  showTypes = false;

  tableTypes: { name: TransactionType; color: string }[] = [
    {
      name: 'standingOrders',
      color: 'is-info',
    },
    {
      name: 'directDebits',
      color: 'is-danger',
    },
    {
      name: 'receivedPayments',
      color: 'is-primary',
    },
  ];

  addNewTable(type: TransactionType) {
    this.transactionTypeSelected.next(type);
    this.toggleTypes();
  }

  toggleTypes() {
    this.showTypes = !this.showTypes;
  }
}
